/* eslint-disable no-tabs */
/* eslint-disable no-unused-vars */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';
import SpectacleViewDescription from '../components/SpectacleViewDescription';
import SpectacleViewPhotos from '../components/SpectacleViewPhotos';
import SpectacleViewVideo from '../components/SpectacleViewVideo';
import { capitalize } from '../Utils/Helpers';

import '../components/SpectacleView.css';

function SpectacleBackdrop({ spectacle, handleBackdrop }) {
  const [t] = useTranslation('pages');
  const [searchParams, setSearchParams] = useSearchParams();
  const [view, setView] = useState('description');
  const [videoUrls, setVideoUrls] = useState(null);

  const handleView = (view) => {
    setSearchParams((prevParams) => {
      const params = new URLSearchParams(prevParams.toString());
      params.set('view', view);
      return params;
    });
  };
  useEffect(() => {
    if (searchParams.has('view')) {
      setView(searchParams.get('view'));
    }
  }, [searchParams]);
  // Check if almost one video link is valid
  useEffect(() => {
    // Asegura que video_link sea un array
    const videoLinks = Array.isArray(spectacle.video_link)
      ? spectacle.video_link
      : [];

    if (videoLinks.length > 0) {
      const regex =
        /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|v\/|embed\/|user\/\S+~)\S+$/;
      const urls = videoLinks
        .map((video) => {
          if (video && typeof video.url === 'string' && regex.test(video.url)) {
            const match = video.url.match(
              /(?:\?v=|\/embed\/|\/\d\/|\/vi\/|youtu\.be\/|\/embed\/|\/v\/|\/e\/|youtu\.be\/|\/v=)([^#\&\?]*).*/
            );
            if (match && match[1]) {
              return `https://www.youtube.com/embed/${match[1]}`;
            }
          }
          return null;
        })
        .filter(Boolean);
      setVideoUrls(urls.length > 0 ? urls : null);
    } else {
      setVideoUrls(null);
    }
  }, [spectacle.video_link]);

  return !spectacle ? (
    <p> Loading... </p>
  ) : (
    <section className="spectacle_backdrop_open no_scroll_bar">
      <section className="head_container">
        <h1>{capitalize(spectacle.title)}</h1>
        <div className="btns_spectacle">
          <p
            className="text-lg sm:text-2xl"
            style={{
              color:
                view === 'description'
                  ? 'var(--active-color)'
                  : 'var(--back-text-color)',
            }}
            onClick={() => handleView('description')}
            aria-label="Bouton description spectacle"
          >
            {t('/SpectacleView.btn-description')}
          </p>
          <p
            className="text-lg sm:text-2xl"
            style={{
              color:
                view === 'photos'
                  ? 'var(--active-color)'
                  : 'var(--back-text-color)',
            }}
            onClick={() => handleView('photos')}
            aria-label="Bouton photos spectacle"
          >
            {t('/SpectacleView.btn-photos')}
          </p>
          {videoUrls && (
            <p
              className="text-lg sm:text-2xl"
              style={{
                color:
                  view === 'video'
                    ? 'var(--active-color)'
                    : 'var(--back-text-color)',
              }}
              onClick={() => handleView('video')}
              aria-label="Bouton videos spectacle"
            >
              {t('/SpectacleView.btn-video')}
            </p>
          )}
          <Link
            className="text-lg sm:text-2xl"
            to={'../Contact'}
            aria-label="Bouton page contact"
          >
            {t('/SpectacleView.btn-contact')}
          </Link>
          {/* TODO : cambiar esto por un boton */}
          <Link
            className="text-lg sm:text-2xl"
            onClick={handleBackdrop}
            aria-label="Bouton retour page spectacles"
          >
            {t('/SpectacleView.btn-retour')}
          </Link>
        </div>
      </section>
      {view === 'description' && (
        <SpectacleViewDescription spectacle={spectacle} />
      )}
      {view === 'photos' && <SpectacleViewPhotos photos={spectacle.images} />}
      {view === 'video' && videoUrls && <SpectacleViewVideo urls={videoUrls} />}
    </section>
  );
}

export default SpectacleBackdrop;
